import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { ID } from "@common/interfaces/id";
import { IKeyvalue } from "@common/interfaces/keyvalue";
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore } from "@datorama/akita";

export interface KeyvalueState extends EntityState<IKeyvalue, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.KEYVALUES , realtimeEntity: 'Keyvalue'})
export class KeyvalueStore extends EntityStore<KeyvalueState> {

  constructor() {
    super([]);
  }

}
